import  React, { useEffect, useState } from 'react';
import { Handle, Position,MarkerType, useReactFlow,useStore,BaseEdge, getBezierPath} from '@xyflow/react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, notification, Space } from 'antd';

import deleteEdge from '../../main'
import './main.css'

const CustomEdge = ({ id, sourceX, sourceY, targetX, targetY, style, data, markerEnd }) => {
    const [hovered, setHovered] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    // const reactFlowInstance = useReactFlow();
    // const project = useStore(state => state.project);


    // Get curved edge path
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });
    useEffect(() => {
        if(!hovered){
            return
        }
        
        // console.log(
        //     targetX
        // )
        console.log(targetX -  Math.abs(targetX - sourceX) < 160 ? 30 : 80)
        console.log("-=-=-=-=")
        // console.log(labelX, labelY)
    },[hovered, mousePosition])

    return (
        <
        
        >
            {/* Render the actual edge */}
            <BaseEdge             
            className='custom-base-edge'
            id={id} path={edgePath}
            
            style={{...style}} markerEnd={markerEnd} />

            <path
            d={edgePath}
            fill="none"
            stroke="transparent"
            className='custom-edge-stroke'
            strokeWidth={40} // Increase hitbox size for better hover detection
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            // onMouseMove={(e) => setMousePosition({ x: e.clientX, y: e.clientY })}
            // onMouseMove={(e) => {
            //     // Convert screen (client) coordinates to flow (SVG) coordinates
            //     const bounds = e.target.ownerSVGElement.getBoundingClientRect();
            //     const x = e.clientX - bounds.left;
            //     const y = e.clientY - bounds.top;
            //     const flowPos = project({ x, y });
            //     setMousePosition(flowPos);
            // }}
        />

            {/* Delete Icon on Hover (Positioned in Middle of Edge) */}
            <g
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            >
                
                {hovered &&    <foreignObject
                        // x = {targetX - 60}
                        // y = {targetY}
                        x={labelX - 16} 
                        y={labelY - 16} 
                        // x={sourceX + 46}
                        // y={sourceY - 16}
                        // x={mousePosition.x - 16} // Center the icon on the cursor
                        // y={mousePosition.y - 16}
                        width={100}
                        height={100}
                        style={{cursor:"pointer", zIndex:""}}
                        >
                        
                        <div className='delete-arrow-bg'
                            style={{zIndex:10, backgroundColor:"white", padding:"10px", width:"10px", border:"1px solid #ddd"}}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    console.log("ForeignObject Clicked!");
                                    console.log("Edge ID:", id);
                                    console.log("Data:", data);
                        
                                    if (data?.onDelete) {
                                        data.onDelete(id);
                                    } else {
                                        // deleteEdge(id)
                                        console.error("onDelete function is not defined!");
                                    }
                                }}
                        >
                        <DeleteOutlined style={{color:"red", fontSize:"10px"}}/>
                        </div>
                        
                    </foreignObject>
                }
            </g>
        </>
    );
};



const CustomHandle = ({ id, onDelete, type }) => {

    const [api, contextHolder] = notification.useNotification();

    
  const openNotification = () => {
    
    api.error({
      message: 'More than one connection',
      description:
        'You can only connect one node to this endpoint.',
      showProgress: true,
      
    });
  };

    const { getEdges } = useReactFlow(); 
    let edgeStyle = { markerEnd: { type: MarkerType.Arrow }, zIndex: 10, background: "#ddd", width: 5, height: 5, borderRadius: "50%" , transform: "translateY(-50%)"}

    let position = type == "source" ? "right" : "left"
     const existingEdges = getEdges(); // Get all edges
    const [edgeConnectionCount, setEdgeConnectionCount] = useState(0);

    return (
        <div>
            {contextHolder}
            <Handle
                type={type} 
                position={position == "right" ? Position.Right : Position.Left} 
                id={`${id}-${position}`}
                style={edgeStyle} 
                isValidConnection={(connection) => {
                    
                    
                    // Allow only one outgoing connection from a source
                    if (type === "source") {
                        const sourceEdges = existingEdges.filter(edge => edge.sourceHandle === connection.targetHandle);
                        setEdgeConnectionCount(sourceEdges.length);

                        // console.log("Source Edges:", sourceEdges);
                        console.log("Edge Connection Count:", edgeConnectionCount);

                        if(sourceEdges.length > 1){
                            openNotification()
                        }
                        return sourceEdges.length === 0;

                    }
                    return true; // Allow multiple incoming connections to the target
                }}
            />
            {/* {
                existingEdges.length > 0 && 
                    <div className='error-message'>
                        <p>Remove connection</p>
                    </div>
            } */}
        </div>
    );
};

export {CustomHandle, CustomEdge};
